import { render, staticRenderFns } from "./commonParams.vue?vue&type=template&id=e8d06c52&scoped=true&"
import script from "./commonParams.vue?vue&type=script&lang=js&"
export * from "./commonParams.vue?vue&type=script&lang=js&"
import style0 from "./commonParams.vue?vue&type=style&index=0&id=e8d06c52&prod&lang=less&scoped=true&"
import style1 from "./commonParams.vue?vue&type=style&index=1&id=e8d06c52&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d06c52",
  null
  
)

export default component.exports